import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import { FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller } from "react-hook-form";
import {Visibility, VisibilityOff} from "@mui/icons-material";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";

// NewProduct page components
import FormField from "../FormField";
import roleService from "../../../../../services/roleService";

// Componente: Paso 1 - Información básica
function UserInfo({ control, errors, isEdit }) {
  const [showPassword, setShowPassword] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const { data } = await roleService.getAll();
        const roles = data;
        setRoleOptions(roles);
      } catch (error) {
        console.error("Error cargando roles:", error);
      }
    };

    fetchRole();
  }, []);

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Sobre el usuario
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="username"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Nombre de usuario"
                error={!!errors.username}
                helperText={errors.username?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                type={showPassword ? "text" : "password"}
                label="Contraseña"
                placeholder={isEdit ? "Dejar vacío para mantener actual" : "Ingresa una contraseña segura"}
                error={!!errors.password}
                helperText={
                  errors.password?.message ||
                  (isEdit
                    ? "Deja vacío si no deseas cambiar la contraseña"
                    : "Mínimo 8 caracteres, con mayúscula, minúscula y número"
                  )
                }
                // Opcional: agregar ícono para mostrar/ocultar contraseña
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="role"
            control={control}
            render={({ field }) => (
              <FormControl fullWidth variant="outlined" error={!!errors.role}>
                <InputLabel id="role-label">Rol</InputLabel>
                <Select
                  {...field}
                  labelId="role-label"
                  label="Role"
                  sx={{ height: 50 }}
                >
                  <MenuItem value="">Seleccionar</MenuItem>
                  {roleOptions.map((option) => (
                    <MenuItem key={option._id} value={option._id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors.role && (
                  <MDTypography variant="caption" ml={2} mt={0.5}>
                    {errors.role.message}
                  </MDTypography>
                )}
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

UserInfo.propTypes = {
  control: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default UserInfo;